/**
 * Wrapper button for the design library button to pass our router specific link
 */

import { Link } from 'react-router-dom';
import { ButtonProps, Button as DesignLibraryButton } from '@mweb/zappos-ui';

const Button = ({ href, ...rest }: Omit<ButtonProps, 'linkComponent' | 'linkProps'>) => (
  <DesignLibraryButton {...rest} href={href} linkComponent={Link} linkProps={{ to: href }} />
);

export default Button;
